(function () {
  var roots = document.querySelectorAll("[data-product-reviews]");
  if (!roots.length) return;

  roots.forEach(function (root) {
    var source = (root.dataset.reviewsSource || "custom").trim();

    // Always wire Write a Review → Judge.me form on product pages (any source).
    bindWriteReviewButton(root);

    if (source === "judgeme") {
      initJudgeMeReviews(root);
      return;
    }

    initCustomReviews(root);
  });

  function bindWriteReviewButton(sectionRoot) {
    var writeBtn = sectionRoot.querySelector("[data-product-reviews-write]");
    if (!writeBtn) return;

    writeBtn.addEventListener("click", function (event) {
      event.preventDefault();
      openJudgeMeWriteForm(0);
    });
  }

  function openJudgeMeWriteForm(attempt) {
    var tryCount = attempt || 0;
    var selectors = [
      '#judgeme_product_reviews [data-testid="write-review-button"]',
      "#judgeme_product_reviews .jdgm-write-rev-link",
      "#judgeme_product_reviews a.jdgm-write-rev-link",
      "#judgeme_product_reviews button.jdgm-write-rev-link",
      ".jdgm-write-rev-link",
      '[data-testid="write-review-button"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var btn = document.querySelector(selectors[i]);
      if (btn) {
        btn.click();
        return;
      }
    }

    // Widget scripts load async via the Judge.me app embed
    if (tryCount < 20) {
      setTimeout(function () {
        openJudgeMeWriteForm(tryCount + 1);
      }, 250);
      return;
    }

    console.warn("product-reviews: Judge.me Write a Review button not found");
  }

  function initCustomReviews(root) {
    var galleryItems = root.querySelectorAll("[data-product-reviews-gallery-item]");
    var moreBtn = root.querySelector("[data-product-reviews-more]");
    var hiddenReviews = root.querySelectorAll("[data-product-reviews-hidden]");

    galleryItems.forEach(function (item) {
      item.addEventListener("click", function () {
        var reviewId = item.getAttribute("data-review-id");
        if (!reviewId) return;

        var review = root.querySelector(
          '[data-product-reviews-item][data-review-id="' + reviewId + '"]'
        );
        if (!review) return;

        review.classList.remove("product-reviews__review--hidden");
        review.scrollIntoView({ behavior: "smooth", block: "nearest" });
      });
    });

    if (!moreBtn || !hiddenReviews.length) {
      if (moreBtn) moreBtn.classList.add("is-hidden");
      return;
    }

    moreBtn.addEventListener("click", function () {
      hiddenReviews.forEach(function (review) {
        review.classList.remove("product-reviews__review--hidden");
      });
      moreBtn.classList.add("is-hidden");
    });
  }

  function initJudgeMeReviews(root) {
    var shopDomain = (root.dataset.shopDomain || "").trim();
    var token = (root.dataset.judgemeToken || "").trim();
    var scope = (root.dataset.judgemeScope || "product").trim();
    if (scope !== "all" && scope !== "store" && scope !== "product") {
      scope = "product";
    }
    var productId = String(root.dataset.productId || "").trim();
    var starIcon = root.dataset.starIcon || "";
    var starEmptyIcon = root.dataset.starEmptyIcon || "";
    var initialCount = parseInt(root.dataset.initialCount, 10) || 4;
    var minRating = parseInt(root.dataset.minRating, 10);
    if (isNaN(minRating) || minRating < 1) minRating = 1;
    if (minRating > 5) minRating = 5;
    var countTemplate = root.dataset.countTemplate || "Based on [count] reviews";
    var headingTemplate = root.dataset.headingTemplate || "[rating] Average Rating";
    var showMoreLabel = root.dataset.showMoreLabel || "Show More";

    var galleryWrap = root.querySelector("[data-product-reviews-gallery-wrap]");
    var galleryList = root.querySelector("[data-product-reviews-gallery]");
    var listWrap = root.querySelector("[data-product-reviews-list]");
    var moreBtn = root.querySelector("[data-product-reviews-more]");
    var countEl = root.querySelector("[data-product-reviews-count]");
    var summaryStars = root.querySelector("[data-product-reviews-summary-stars]");
    var titleEl = root.querySelector("[data-product-reviews-title]");

    if (!token || !shopDomain || !listWrap) {
      console.warn("product-reviews: missing Judge.me token, shop domain, or list container");
      return;
    }
    if (scope === "product" && !productId) {
      console.warn("product-reviews: Judge.me product scope needs a product id");
      return;
    }

    fetchProductReviews()
      .then(function (reviews) {
        reviews = reviews || [];

        var listedReviews = reviews.filter(function (r) {
          return (r.rating || 0) >= minRating;
        });

        if (reviews.length) {
          updateSummary(reviews);
        }
        renderGallery(listedReviews);
        renderReviews(listedReviews);
      })
      .catch(function (err) {
        console.error("product-reviews: Judge.me fetch failed", err);
      });

    // Shopify product id only — never r.external_id / r.product_id (Judge.me internal ids).
    function reviewProductId(r) {
      if (!r) return "";

      if (r.product_external_id != null && String(r.product_external_id).trim() !== "") {
        return String(r.product_external_id).trim();
      }

      if (r.product && r.product.external_id != null && String(r.product.external_id).trim() !== "") {
        return String(r.product.external_id).trim();
      }

      // Already-normalized reviews keep this field
      if (r.shopify_product_id != null && String(r.shopify_product_id).trim() !== "") {
        return String(r.shopify_product_id).trim();
      }

      return "";
    }

    function isStoreReview(r) {
      if (!r) return false;
      if (r.is_store_review === true) return true;

      // Store reviews are not linked to a Shopify product / handle / title
      var hasShopifyProduct = !!reviewProductId(r);
      var hasHandle =
        r.product_handle != null && String(r.product_handle).trim() !== "";
      var hasTitle =
        r.product_title != null && String(r.product_title).trim() !== "";

      return !hasShopifyProduct && !hasHandle && !hasTitle;
    }

    function matchesScope(r) {
      if (scope === "store") return isStoreReview(r);
      if (scope === "product") return reviewProductId(r) === String(productId);
      // all — every review (product + store)
      return true;
    }

    function fetchProductReviews() {
      if (scope === "store") {
        return fetchStoreReviews();
      }

      var useShopWideFetch = scope === "all";
      return fetchReviewsForScope(useShopWideFetch).then(function (reviews) {
        return (reviews || []).filter(matchesScope);
      });
    }

    // Store reviews: Judge.me widget needs review_type=shop-reviews
    // (default all_reviews_page returns product reviews only).
    function fetchStoreReviews() {
      return tryRestAPI(true)
        .then(function (reviews) {
          var storeOnly = (reviews || []).filter(isStoreReview);
          if (storeOnly.length) return storeOnly;
          return tryShopReviewsWidget();
        })
        .catch(function () {
          return tryShopReviewsWidget();
        });
    }

    function fetchReviewsForScope(useAllReviews) {
      return tryRestAPI(useAllReviews)
        .then(function (reviews) {
          if (reviews && reviews.length) return reviews;
          return tryWidgetAPI(useAllReviews);
        })
        .catch(function () {
          return tryWidgetAPI(useAllReviews);
        });
    }

    function tryRestAPI(useAllReviews) {
      var collected = [];

      function fetchPage(page) {
        var url =
          "https://judge.me/api/v1/reviews" +
          "?api_token=" +
          encodeURIComponent(token) +
          "&shop_domain=" +
          encodeURIComponent(shopDomain) +
          "&per_page=100&page=" +
          page;

        return fetch(url)
          .then(function (res) {
            if (!res.ok) throw new Error("REST " + res.status);
            return res.json();
          })
          .then(function (data) {
            var reviews = data.reviews || [];

            reviews.forEach(function (r) {
              if (isReviewHidden(r)) return;
              // Pre-filter product scope on the raw payload (before normalize)
              if (!useAllReviews && reviewProductId(r) !== String(productId)) return;
              collected.push(normalizeReview(r));
            });

            if (reviews.length >= 100 && page < 10) {
              return fetchPage(page + 1);
            }
            return collected;
          });
      }

      return fetchPage(1);
    }

    function tryShopReviewsWidget() {
      var url =
        "https://judge.me/api/v1/widgets/all_reviews_page" +
        "?api_token=" +
        encodeURIComponent(token) +
        "&shop_domain=" +
        encodeURIComponent(shopDomain) +
        "&per_page=50&page=1" +
        "&review_type=shop-reviews";

      return fetchWidgetHtml(url).then(function (html) {
        return parseReviewsFromHtml(html, "").map(function (review) {
          review.shopify_product_id = "";
          review.is_store_review = true;
          return review;
        });
      });
    }

    function tryWidgetAPI(useAllReviews) {
      var widgetType = useAllReviews ? "all_reviews_page" : "product_review";
      var url =
        "https://judge.me/api/v1/widgets/" +
        widgetType +
        "?api_token=" +
        encodeURIComponent(token) +
        "&shop_domain=" +
        encodeURIComponent(shopDomain) +
        "&per_page=50&page=1";

      if (useAllReviews) {
        url += "&review_type=product-reviews";
      }

      if (!useAllReviews && productId) {
        url += "&external_id=" + encodeURIComponent(productId);
      }

      return fetchWidgetHtml(url).then(function (html) {
        // Product widget = all cards belong to this Shopify product
        return parseReviewsFromHtml(html, useAllReviews ? "" : productId);
      });
    }

    function fetchWidgetHtml(url) {
      return fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error("Widget " + res.status);
          return res.text();
        })
        .then(function (text) {
          var html = "";
          try {
            var json = JSON.parse(text);
            html = json.widget || json.html || json.body || "";
            if (!html) {
              for (var k in json) {
                if (typeof json[k] === "string" && json[k].length > 100) {
                  html = json[k];
                  break;
                }
              }
            }
          } catch (e) {
            html = text;
          }
          return html;
        });
    }

    function normalizeReview(r) {
      var pics = [];
      if (r.pictures && r.pictures.length) {
        r.pictures.forEach(function (p) {
          if (isPictureHidden(p)) return;
          var thumb =
            (p.urls && (p.urls.compact || p.urls.small || p.urls.original)) || "";
          var full = getMaxUrl(p) || thumb;
          if (thumb) pics.push({ thumb: thumb, full: full });
        });
      }

      var shopifyProductId = reviewProductId(r);
      var storeReview = isStoreReview(r);

      return {
        id: String(r.id || Math.random()),
        body: r.body || "",
        title: r.title || "",
        rating: parseInt(r.rating, 10) || 5,
        author: (r.reviewer && r.reviewer.name) || r.reviewer_name || "Customer",
        verified: r.verified === "buyer" || r.verified === true,
        created_at: r.created_at || r.updated_at || r.date || "",
        pictures: pics,
        product_handle: r.product_handle || "",
        product_title: r.product_title || "",
        shopify_product_id: storeReview ? "" : shopifyProductId,
        is_store_review: storeReview
      };
    }

    function parseReviewsFromHtml(html, fallbackProductId) {
      if (!html || !html.trim()) return [];
      var temp = document.createElement("div");
      temp.innerHTML = html;
      var results = [];
      var selectors = [
        ".jdgm-rev",
        ".jdgm-carousel-item",
        "[data-review-id]",
        ".jdgm-rev-widg__review",
        ".jdgm-all-reviews__review"
      ];

      for (var i = 0; i < selectors.length; i++) {
        var items = temp.querySelectorAll(selectors[i]);
        if (!items.length) continue;

        items.forEach(function (item) {
          var cls = item.className || "";
          if (cls.indexOf("jdgm--hidden") !== -1 || cls.indexOf("jdgm-hidden") !== -1) return;
          if (item.hasAttribute("hidden") || item.getAttribute("aria-hidden") === "true") return;

          var body = txtFrom(item, [".jdgm-rev__body", ".jdgm-carousel-item__review-body", ".jdgm-rev__content"]);
          var title = txtFrom(item, [".jdgm-rev__title"]);
          var author =
            txtFrom(item, [".jdgm-rev__author", ".jdgm-carousel-item__reviewer-name"]) || "Customer";
          var rating = ratingFrom(item);
          var picUrl = imgFrom(item, [
            ".jdgm-rev__pic-img",
            ".jdgm-rev__pics img",
            ".jdgm-carousel-item__picture img"
          ]);
          var dateStr = dateFrom(item);

          if (!body && author === "Customer") return;

          var fromDom =
            item.getAttribute("data-product-id") ||
            item.getAttribute("data-external-id") ||
            "";
          var shopifyProductId = String(fromDom || fallbackProductId || "").trim();

          results.push({
            id: item.getAttribute("data-review-id") || String(results.length),
            body: body,
            title: title,
            rating: rating,
            author: author,
            verified: !!item.querySelector(".jdgm-rev__buyer-badge, .jdgm-verified"),
            created_at: dateStr,
            pictures: picUrl ? [{ thumb: picUrl, full: picUrl }] : [],
            shopify_product_id: shopifyProductId,
            is_store_review: !shopifyProductId
          });
        });

        if (results.length) return results;
      }

      return results;
    }

    function dateFrom(item) {
      var ts = item.querySelector(
        ".jdgm-rev__timestamp, .jdgm-rev__date, time, [datetime], [data-content]"
      );
      if (!ts) return "";
      return (
        ts.getAttribute("data-content") ||
        ts.getAttribute("datetime") ||
        ts.getAttribute("title") ||
        (ts.textContent || "").trim() ||
        ""
      );
    }

    function updateSummary(reviews) {
      var sum = 0;
      reviews.forEach(function (r) {
        sum += r.rating || 0;
      });
      var avgExact = reviews.length ? sum / reviews.length : 0;
      var avgRounded = Math.round(avgExact);
      var avgLabel = formatRating(avgExact);

      if (titleEl && headingTemplate) {
        titleEl.textContent = headingTemplate.replace(/\[rating\]/gi, avgLabel);
      }

      if (countEl) {
        countEl.hidden = false;
        countEl.textContent = countTemplate.replace("[count]", String(reviews.length));
      }

      if (!summaryStars || !reviews.length) return;

      summaryStars.setAttribute("aria-label", "Rated " + avgLabel + " out of 5");
      summaryStars.innerHTML = "";
      for (var i = 1; i <= 5; i++) {
        var li = document.createElement("li");
        li.appendChild(starImg(i <= avgRounded ? starIcon : starEmptyIcon, i > avgRounded));
        summaryStars.appendChild(li);
      }
    }

    function formatRating(value) {
      var n = Math.round(value * 10) / 10;
      return n % 1 === 0 ? String(n.toFixed(0)) : String(n.toFixed(1));
    }

    function renderGallery(reviews) {
      if (!galleryWrap || !galleryList) return;

      var items = [];
      reviews.forEach(function (review) {
        if (!review.pictures || !review.pictures.length) return;
        items.push({
          reviewId: review.id,
          thumb: review.pictures[0].thumb,
          author: review.author
        });
      });

      if (!items.length) {
        galleryWrap.hidden = true;
        return;
      }

      galleryList.innerHTML = "";
      items.forEach(function (item) {
        var li = mkEl("li", "product-reviews__gallery-item");
        var btn = mkEl("button", "product-reviews__gallery-trigger");
        btn.type = "button";
        btn.setAttribute("data-product-reviews-gallery-item", "");
        btn.setAttribute("data-review-id", item.reviewId);
        btn.setAttribute("aria-label", "Show review by " + item.author);

        var img = document.createElement("img");
        img.src = item.thumb;
        img.alt = item.author || "";
        img.width = 110;
        img.height = 110;
        img.loading = "lazy";
        btn.appendChild(img);

        btn.addEventListener("click", function () {
          var review = root.querySelector(
            '[data-product-reviews-item][data-review-id="' + item.reviewId + '"]'
          );
          if (!review) return;
          review.classList.remove("product-reviews__review--hidden");
          review.scrollIntoView({ behavior: "smooth", block: "nearest" });
        });

        li.appendChild(btn);
        galleryList.appendChild(li);
      });

      galleryWrap.hidden = false;
    }

    function renderReviews(reviews) {
      listWrap.innerHTML = "";

      reviews.forEach(function (review, idx) {
        var isHidden = idx >= initialCount;
        var article = mkEl(
          "article",
          "product-reviews__review" + (isHidden ? " product-reviews__review--hidden" : "")
        );
        article.id = "product-review-" + review.id;
        article.setAttribute("data-product-reviews-item", "");
        article.setAttribute("data-review-id", review.id);
        if (isHidden) article.setAttribute("data-product-reviews-hidden", "");

        var author = mkEl("div", "product-reviews__author");
        author.appendChild(mkEl("p", "product-reviews__name", review.author));
        var dateText = formatDate(review.created_at);
        if (dateText) {
          author.appendChild(mkEl("p", "product-reviews__date", dateText));
        }
        article.appendChild(author);

        var body = mkEl("div", "product-reviews__body");
        body.appendChild(buildStarsList(review.rating));
        if (review.title) {
          body.appendChild(mkEl("h3", "h3 product-reviews__review-title", review.title));
        }
        if (review.body) {
          body.appendChild(mkEl("p", "product-reviews__text", review.body));
        }
        article.appendChild(body);

        var media = mkEl("div", "product-reviews__media");
        if (review.pictures.length) {
          var img = document.createElement("img");
          img.src = review.pictures[0].thumb;
          img.alt = review.author || "";
          img.width = 67;
          img.height = 67;
          img.loading = "lazy";
          media.appendChild(img);
        }
        article.appendChild(media);

        listWrap.appendChild(article);
      });

      if (reviews.length > initialCount && moreBtn) {
        moreBtn.hidden = false;
        moreBtn.classList.remove("is-hidden");
        moreBtn.textContent = showMoreLabel;
        moreBtn.addEventListener("click", function () {
          listWrap.querySelectorAll("[data-product-reviews-hidden]").forEach(function (el) {
            el.classList.remove("product-reviews__review--hidden");
            el.removeAttribute("data-product-reviews-hidden");
          });
          moreBtn.classList.add("is-hidden");
          moreBtn.hidden = true;
        });
      } else if (moreBtn) {
        moreBtn.classList.add("is-hidden");
        moreBtn.hidden = true;
      }
    }

    function buildStarsList(rating) {
      var ul = mkEl("ul", "product-reviews__stars");
      ul.setAttribute("aria-label", "Rated " + rating + " out of 5");
      for (var i = 1; i <= 5; i++) {
        var li = document.createElement("li");
        li.appendChild(starImg(i <= rating ? starIcon : starEmptyIcon, i > rating));
        ul.appendChild(li);
      }
      return ul;
    }

    function starImg(src, empty) {
      var img = document.createElement("img");
      img.className =
        "product-reviews__star" + (empty ? " product-reviews__star--empty" : "");
      img.src = src;
      img.alt = "";
      img.width = 16;
      img.height = 16;
      return img;
    }

    function formatDate(value) {
      if (!value) return "";
      var raw = String(value).trim();
      if (!raw) return "";

      // Already formatted like 12.09.2026
      if (/^\d{1,2}\.\d{1,2}\.\d{2,4}$/.test(raw)) return raw;

      var d = new Date(raw);
      if (isNaN(d.getTime())) {
        // Judge.me sometimes sends "2022-05-12 04:38:32 UTC"
        d = new Date(raw.replace(" ", "T").replace(" UTC", "Z"));
      }
      if (isNaN(d.getTime())) return raw;

      var day = ("0" + d.getDate()).slice(-2);
      var month = ("0" + (d.getMonth() + 1)).slice(-2);
      return day + "." + month + "." + d.getFullYear();
    }

    function isTruthyFlag(value) {
      return value === true || value === 1 || value === "1" || value === "true";
    }

    function isReviewHidden(r) {
      if (!r) return true;
      if (isTruthyFlag(r.hidden)) return true;
      if (r.curated === "spam" || r.curated === "hold") return true;
      return false;
    }

    function isPictureHidden(p) {
      if (!p) return true;
      return isTruthyFlag(p.hidden);
    }

    function getMaxUrl(pic) {
      if (!pic) return "";
      var raw = pic.image_url || (pic.image && pic.image.url) || pic.url || "";
      var fromUrls = "";
      if (pic.urls) {
        fromUrls = pic.urls.huge || pic.urls.large || pic.urls.original || "";
      }
      return stripImageParams(raw || fromUrls || "");
    }

    function stripImageParams(url) {
      if (!url) return url;
      return url.split("?")[0];
    }

    function txtFrom(container, sels) {
      for (var i = 0; i < sels.length; i++) {
        var el = container.querySelector(sels[i]);
        if (el) {
          var t = el.textContent.trim();
          if (t) return t;
        }
      }
      return "";
    }

    function ratingFrom(el) {
      var rEl = el.querySelector(".jdgm-rev__rating, .jdgm-carousel-item__review-rating");
      if (rEl) {
        var sc = parseInt(rEl.getAttribute("data-score"), 10);
        if (sc) return sc;
        var on = rEl.querySelectorAll(".jdgm-star.jdgm--on, .jdgm--on");
        if (on.length) return on.length;
      }
      return parseInt(el.getAttribute("data-score"), 10) || 5;
    }

    function imgFrom(container, sels) {
      for (var i = 0; i < sels.length; i++) {
        var el = container.querySelector(sels[i]);
        if (el) {
          var s = el.getAttribute("src") || el.getAttribute("data-src") || "";
          if (s && s.indexOf("data:") !== 0) return s;
        }
      }
      return "";
    }

    function mkEl(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (text != null) node.textContent = text;
      return node;
    }
  }
})();
